var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaasinline = function SvgSaasinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B68EE",
    fillRule: "evenodd",
    d: "m20.907 11.242.767 1.202 1.386-.334a4 4 0 0 1 4.904 4.426c-.046.352-.238.667-.766.958-.571.314-1.405.506-2.302.506H11.787c-1.035 0-2.008-.261-2.694-.689-.65-.405-.979-.904-1.048-1.51a7 7 0 0 1 12.862-4.56ZM15 6a8.993 8.993 0 0 1 7.593 4.166 6 6 0 0 1 7.354 6.635c-.3 2.255-2.775 3.199-5.05 3.199H19v2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h8v-2h-5.213c-2.67 0-5.428-1.32-5.729-3.973A9 9 0 0 1 15 6ZM9 24h18v4H9v-4Zm13 1a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
    clipRule: "evenodd"
  })));
};
export default SvgSaasinline;